
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({
  name: 'CompleteConfirmationDialog',
  emits: ['update:modelValue', 'confirm', 'cancel'],
})
export default class CompleteConfirmationDialog extends Vue {
  @Prop({ type: Boolean, default: false }) modelValue!: boolean

  handleConfirm() {
    this.$emit('confirm')
  }

  handleCancel() {
    this.$emit('cancel')
    this.$emit('update:modelValue', false)
  }
}
